$w.onReady(function () {
    $w('#submit').onClick(() => {
        $w('#Name').updateValidityIndication()
        $w('#Email').updateValidityIndication()
        $w('#Message').updateValidityIndication()
        $w('#dropdown').updateValidityIndication()
        if ($w('#Name').valid && $w('#Email').valid && $w('#Message').valid && $w('#dropdown').valid) {
            const dataset = $w(`#wf${$w('#dropdown').selectedIndex + 1}`)
            dataset.setFieldValues({
                "Name": $w('#Name').value,
                "Email": $w('#Email').value,
                "Message": $w('#Message').value
            })
            dataset.save()
                .then(() => {
                    $w('#Name').value = ""
                    $w('#Email').value = ""
                    $w('#Message').value = ""
                    $w('#dropdown').selectedIndex = null
                    $w('#Name').resetValidityIndication()
                    $w('#Email').resetValidityIndication()
                    $w('#Message').resetValidityIndication()
                    $w('#dropdown').resetValidityIndication()
                    $w('#success').show()
                })
        }

    })
});